import { useNode } from '@craftjs/core';
import { Stack, TextField } from '@mui/material';
import useResponsiveValues, {
  ResponsiveValue,
} from '@/components/editor/hooks/useResponsiveValues';

export interface BorderRadius {
  borderTopLeftRadius?: string | ResponsiveValue<string>;
  borderTopRightRadius?: string | ResponsiveValue<string>;
  borderBottomRightRadius?: string | ResponsiveValue<string>;
  borderBottomLeftRadius?: string | ResponsiveValue<string>;
}

const BorderRadiusSettings = () => {
  const {
    props,
    actions: { setProp },
  } = useNode((node) => ({
    props: node.data.props,
  }));

  const responsive = useResponsiveValues();

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2}>
        <TextField
          label="Sup Izquierda"
          size="small"
          fullWidth
          value={responsive.getValue(props.borderTopLeftRadius)}
          onChange={(e) => {
            setProp((props: BorderRadius) => {
              props.borderTopLeftRadius = responsive.setValue(
                props.borderTopLeftRadius,
                e.target.value
              );
              return props;
            });
          }}
        />
        <TextField
          label="Sup Derecha"
          size="small"
          fullWidth
          value={responsive.getValue(props.borderTopRightRadius)}
          onChange={(e) => {
            setProp((props: BorderRadius) => {
              props.borderTopRightRadius = responsive.setValue(
                props.borderTopRightRadius,
                e.target.value
              );
              return props;
            });
          }}
        />
      </Stack>
      <Stack direction="row" spacing={2}>
        <TextField
          label="Inf Izquierda"
          size="small"
          fullWidth
          value={responsive.getValue(props.borderBottomLeftRadius)}
          onChange={(e) => {
            setProp((props: BorderRadius) => {
              props.borderBottomLeftRadius = responsive.setValue(
                props.borderBottomLeftRadius,
                e.target.value
              );
              return props;
            });
          }}
        />
        <TextField
          label="Inf Derecha"
          size="small"
          fullWidth
          value={responsive.getValue(props.borderBottomRightRadius)}
          onChange={(e) => {
            setProp((props: BorderRadius) => {
              props.borderBottomRightRadius = responsive.setValue(
                props.borderBottomRightRadius,
                e.target.value
              );
              return props;
            });
          }}
        />
      </Stack>
    </Stack>
  );
};

export default BorderRadiusSettings;
